<template>
	<header id="header" class="page-header" :style="{'background-image': `url(${urlImageHeader})`}">
		<div class="retour-site">
			<a href="https://www.greta-cfa-paysdelaloire.fr/" class="link-to-site" target="_blank">
				Le site des <strong>GRETA pays de la loire</strong>
			</a>
			<KookBtn
				class="--angle-left retour-blog --not-bold"
				texte="Page d'accueil du blog"
				:href="urlLogo"
				:blank="false"
			/>
		</div>
		<a :href="urlLogo" class="logo-container">
			<img src="../../assets/img/logo.png" alt="Image Header" class="logo" />
		</a>
		<div class="rs-container">
			<BtnRS
				v-for="(btnRsUrl, btnRsName) in btnRsTab"
				:key="btnRsName"
				:icone="btnRsName"
				:url="btnRsUrl"
				class="--border-orange --bg-transparent --color-white --size-40"
			/>
		</div>
	</header>
</template>

<script>
import BtnRS from '@components/global/Btn-rs';
import KookBtn from '@components/global/KookBtn';

import CategoryPicker from '@components/post/category-picker';
/**
 * Template de posts permettant d'afficher tous les articles du blog
 */
export default {
	props: {
		/**
		 * Composant dans single ou non ?
		 */
		isSingle: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			urlImageHeader: '',
			btnRsTab: {
				'twitter': 'https://twitter.com/gretacfapdl',
				'facebook': 'https://www.facebook.com/greta.cfa.paysdelaloire',
				'linkedin': 'https://www.linkedin.com/company/greta-cfapaysdelaloire/',
				'youtube-play': 'https://www.youtube.com/channel/UCIkOjqNK5sZTzPsM9ceYDRQ'
			},
			urlLogo: 'https://blog.greta-cfa-paysdelaloire.fr/',
		};
	},
	mounted() {
		if (!this.isSingle) {
			$api.getField('image_header', 'pages', WP.__PAGE__).then((res) => {
				let idImage = res.data.image_header;

				$api.getMedia(idImage).then((res) => {
					this.urlImageHeader = res.data.guid.rendered;
				});
			});
		}
		this.urlLogo = WP.__PAGE__ == 7599 ? '#' : '/';
	},
	components: {
		BtnRS,
		KookBtn,
		CategoryPicker,
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/_vars.scss';

header {
	position: relative;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	align-items: flex-start;
	justify-items: center;
	height: 440px;
	padding: 50px;
	color: $mainColor;
	background-size: cover;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		background-color: rgba(22, 54, 88, 0.7);
	}

	& > * {
		position: relative;
		z-index: 1;
	}

	.retour-site,
	.rs-container {
		margin-top: 40px;

		@media screen and (max-width: $break-medium) {
			margin: 0;
		}
	}

	.retour-blog {
		margin-top: 15px;
	}

	.retour-site {
		justify-self: flex-start;

		@media screen and (max-width: $break-medium) {
			display: none;
		}
	}

	.logo-container {
		@media screen and (max-width: $break-medium) {
			margin: 0;
			max-height: 100px;
		}

		img {
			max-height: 100px;
		}
	}

	.link-to-site {
		display: block;
		color: white;
		text-decoration: underline;
	}

	.rs-container {
		justify-self: flex-end;
		display: flex;
		align-items: center;
	}

	.btn-rs + .btn-rs {
		margin-left: 25px;
	}

	@media screen and (max-width: $break-medium) {
		display: flex;
		flex-direction: column-reverse;
		align-items: center;
		justify-content: flex-end;
		height: auto;
		padding: 20px 20px 0 0;

		.rs-container {
			align-self: flex-end;
		}
	}
}

body.home {
	header .retour-blog {
		display: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/Header.vue